module.exports = {
  "interaction": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "creationError": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "statusMessage": "string"
    },
    "namespace": "signup"
  },
  "browserButton": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "fromStep": "string",
      "toStep": "string"
    },
    "namespace": "signup"
  },
  "leavePage": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "leavingStep": "string"
    },
    "namespace": "signup"
  },
  "compareLanguage": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "referrerLanguage": "string",
      "browserLanguage": "string"
    },
    "namespace": "signup"
  },
  "setLanguage": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "language": "string",
      "languageOrigin": "string"
    },
    "namespace": "signup"
  },
  "setupStarted": {
    "name": "setup started",
    "class": "usage",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "setupCompleted": {
    "name": "setup completed",
    "class": "usage",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "invitedUserPasswordSet": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "stage": [
        "attempt",
        "success"
      ]
    },
    "namespace": "signup"
  },
  "redirect": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "userInitiated": "boolean"
    },
    "namespace": "signup"
  },
  "portalCreated": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "portalId": "number",
      "newUser": "boolean"
    },
    "namespace": "signup"
  },
  "click": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "linkLocation": "string"
    },
    "namespace": "signup"
  },
  "view": {
    "name": "signup interaction",
    "class": "view",
    "properties": {
      "screen": "string"
    },
    "namespace": "signup"
  },
  "error": {
    "name": "signup interaction",
    "class": "error",
    "properties": {
      "errorType": "string",
      "details": "string",
      "userInitiated": "boolean"
    },
    "namespace": "signup"
  },
  "form": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "formSection": "string"
    },
    "namespace": "signup"
  },
  "formError": {
    "name": "signup interaction",
    "class": "error",
    "properties": {
      "eventSubtype": "string",
      "formError": "string"
    },
    "namespace": "signup"
  },
  "authState": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "eventSubtype": "string"
    },
    "namespace": "signup"
  },
  "count": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "value": "number"
    },
    "namespace": "signup"
  },
  "countSelectedExisting": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "sentTo": "string",
      "wasRecommended": "boolean",
      "numberOfExistingAccounts": "number"
    },
    "namespace": "signup"
  },
  "mabRequested": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "mab": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "selectedOption": "string"
    },
    "namespace": "signup"
  },
  "mabFailed": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "surveyInteraction": {
    "name": "survey interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "signup"
  },
  "partner": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "partnerId": "string"
    },
    "namespace": "signup"
  },
  "verificationExposure": {
    "name": "signup interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "exposed": "boolean",
      "expVersion": "string"
    },
    "namespace": "signup"
  },
  "signupInitiated": {
    "name": "signup initiated",
    "class": "interaction",
    "namespace": "signup"
  },
  "stepCompleted": {
    "name": "signup step completed",
    "class": "interaction",
    "properties": {
      "stepNumber": "number",
      "totalSteps": "number"
    },
    "namespace": "signup"
  },
  "signupDone": {
    "name": "signup done",
    "class": "interaction",
    "properties": {
      "newUser": "boolean",
      "newPortal": "boolean"
    },
    "namespace": "signup"
  },
  "signupStarted": {
    "name": "signup started",
    "class": "interaction",
    "namespace": "signup"
  },
  "signupCompleted": {
    "name": "signup completed",
    "class": "signup",
    "properties": {
      "newUser": "boolean"
    },
    "namespace": "signup"
  }
};